import styled from 'styled-components'

import { helpers } from 'styles'

import { ButtonLink } from 'components/Buttons'

export const ButtonDownload = styled(ButtonLink)`
	margin: 0;
	border-radius: 0;
	font-size: ${helpers.font.size.base};
	height: 32px;
	margin-bottom: 12px;
	text-align: left;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1.2;

	&:first-child {
		border-radius: 4px 0 0 4px;
		margin-left: 16px;
	}

	&:last-child {
		border-radius: 0 4px 4px 0;
		border-left: 1px solid ${helpers.color.border};
		margin-right: 16px;
	}
`
